import {
  StateRule,
  StateTransitionOptions,
  StateResult,

  StateNavigationAction,
  Transition,
  // eslint-disable-next-line
  addNavigationElement,
  // eslint-disable-next-line
  addEmptyNavigationElement,
  addPreviousNext,
  // eslint-disable-next-line
  addPrevious,
  // eslint-disable-next-line
  addNext,  
  newTransition,
  newTransitionCondition
} from "../StateInterfaces";
import { NavigatonIcons } from "@/business/application/NavConst";
import {Commands} from "@/business/application/commands/Command";
import { BaseState } from "../StateMachine";
import { StateHunting } from "./StateHunting";
import { StateWildBookEntry } from "./StateWildBookEntry";
import { Resource } from "@/infrastructure/resource/resource";


export class StateWildBook extends BaseState {

  private mainState = "WildBook";
  private startState = "WildBook"
  private static transitions: Transition[] = [];  
  private static callingState : StateResult = {oldMainState: '' , oldState: '' , newMainState: '' , newState: '', routeName: ''}
  private isDirectionNext = false

  // Diesen Status setzen wenn es auf den Main-Status zurück geht. 
  private isDirectionPreviousParent = true

  public constructor() {
    super()    
  }


  
  public next(rule: StateRule, options: StateTransitionOptions): StateResult {    
    return this.calculateState(rule, options, false, this.mainState);
  }
  public previous(rule: StateRule,options: StateTransitionOptions): StateResult {    
    return this.calculateState(rule, options, true, this.mainState);
  }

  protected calculateState(rule: StateRule,options: StateTransitionOptions, isPrevious: boolean, mainState: string): StateResult {
    this.isDirectionNext = ! isPrevious
    const context = this.getContext()
    const currentResultState = context.getCurrentResultState();

    if ( isPrevious && this.isDirectionPreviousParent && currentResultState.newState === "WildBook") {
      return this.checkResultState(StateWildBook.callingState);
    }

    let condition = this.calculateBusinessConditions(rule,this.getContext().getCurrentState());
    if ( condition === undefined || condition === null || condition.length === 0 || condition === "") {
     
      if ( currentResultState.newState === "WildBook"  && this.isDirectionNext && condition === "") {
        condition = "WildBookFilter";
      }
     


      if ( currentResultState.newState === "WildBookFilter"  && !this.isDirectionNext && condition === "") {
        condition = "WildBook";
      }
      if ( currentResultState.newState === "WildBook"  && !this.isDirectionNext && condition === "") {
        condition = "Hunting";
      }
    }

    if ( this.isDirectionNext ) {
      const nextTransition = this.getTransitions().filter(row => { 
        if ( row.nav !== StateNavigationAction.Previous && row.condition === condition ) {
          return true
        }
      })
      return this.checkState(nextTransition[0], options);
    } else {
      const previosTransition = this.getTransitions().filter(row => { 
        if ( row.nav === StateNavigationAction.Previous && row.condition === condition ) {
          return true
        }
      })
      return this.checkState(previosTransition[0], options);
    }
  }


  protected calculateBusinessConditions(rule: StateRule, resultState: StateResult): string {
    if ( rule.conditions === undefined || rule.conditions === null || rule.conditions.length === 0 ) {
      return "";
    }

    if (rule.conditions.length == 1) {
      return rule.conditions[0].value;
    }

    return "";
  }


  private getCallingState(condition: string) : StateResult {
    if (this.isDirectionPreviousParent) { 
      // Condition = "Login"
      StateWildBook.callingState.newMainState = condition
      StateWildBook.callingState.newState = condition
      StateWildBook.callingState.routeName = condition
      StateWildBook.callingState.oldMainState = this.mainState
      StateWildBook.callingState.oldState = this.startState

      return StateWildBook.callingState;
    }
     StateWildBook.callingState = {oldMainState: '' , oldState: '' , newMainState: '' , newState: '', routeName: ''};
     return StateWildBook.callingState;
  }

  public getStartTransition(condition: string) : StateResult {
    StateWildBook.transitions = []
    this.getTransitions()
    //if ( condition !== this.mainState) {
      StateWildBook.callingState = this.getCallingState(condition);
    //}
    const t = this.getTransitions()[0];
    return this.getTransition(t);
  }



  protected checkState( transition: Transition, options: StateTransitionOptions): StateResult {
    let newMainState = this.mainState    
    let skip = false
    const newResultState: StateResult = this.getTransition(transition)

    if ( this.isDirectionPreviousParent && !this.isDirectionNext) {
      newMainState = StateWildBook.callingState.oldMainState
    }
    else {      
      newMainState = transition.newMainState
      if (transition.newState == "")
        skip = true
    }

    if (!options.lookahead && transition.newState != "") {
      return this.changeResultState(transition.newMainState, newResultState);
    }
    return newResultState;
  }

  private checkResultState( stateResult: StateResult ) : StateResult {  
    const newResultState = StateWildBook.callingState;    
    return this.changeResultState(stateResult.newMainState, newResultState);      
  }

  private changeResultState(newMainStatePar: string , compResultState: StateResult) : StateResult {
    let newState: any;
    switch (newMainStatePar) {
        case "Hunting":
          newState = new StateHunting();
          compResultState = newState.getStartTransition("Hunting")
          this.getContext().transitionTo(newState,compResultState);
          break;  
        case "WildBookEntry":
          newState = new StateWildBookEntry();
          compResultState = newState.getStartTransition("WildBook")
          this.getContext().transitionTo(newState,compResultState);
          break;  
        default:
          this.getContext().transitionTo(new StateWildBook(), compResultState);        
    }
    return compResultState;
  }




  //-- Sammlung aller Statusübergänge
  public getTransitions(): Transition[] {
    if (StateWildBook.transitions.length === 0) {

      //__ Start State egal von welcher Stufe aus
      //
      let t: Transition = { mainState: "*", newMainState: this.mainState, nav: StateNavigationAction.Next, oldState: "*", newState: this.startState, condition: "Start"};      
      t = addPrevious( t, Commands.PreviousPage )
      t = addNavigationElement(t,1,{command: Commands.PreviousPage, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Zurueck",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Previous });
      t = addEmptyNavigationElement(t,2);
      t = addNavigationElement(t,3,{command: Commands.Pdf, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Pdf",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Pdf });
      t = addNavigationElement(t,4,{command: Commands.Information, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Info",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Information });
      StateWildBook.transitions.push(t);

      t = { mainState: this.mainState, newMainState: "WildBookFilter", nav: StateNavigationAction.Next, oldState: this.startState, newState: "WildBookFilter", condition: "WildBookFilter"};      
      t = addPrevious( t, Commands.PreviousPage )
      StateWildBook.transitions.push(t);

      t = { mainState: this.mainState, newMainState: this.mainState, nav: StateNavigationAction.Next, oldState: this.startState, newState: "WildBook", condition: "WildBookFilterRequest"};      
      t = addPrevious( t, Commands.PreviousPage )
      t = addNavigationElement(t,1,{command: Commands.PreviousPage, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Zurueck",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Previous });
      t = addEmptyNavigationElement(t,2);
      t = addNavigationElement(t,3,{command: Commands.Pdf, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Pdf",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Pdf });
      t = addNavigationElement(t,4,{command: Commands.Information, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Info",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Information });
      StateWildBook.transitions.push(t);


      //__ Backward Previous gesetzt
      t = { mainState: this.mainState, newMainState: this.mainState, nav: StateNavigationAction.Previous, oldState: "WildBookFilter", newState: "WildBook", condition: "WildBook"};      
      t = addPrevious( t, Commands.PreviousPage )
      t = addNavigationElement(t,1,{command: Commands.PreviousPage, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Zurueck",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Previous });
      t = addEmptyNavigationElement(t,2);
      t = addNavigationElement(t,3,{command: Commands.Pdf, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Pdf",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Pdf });
      t = addNavigationElement(t,4,{command: Commands.Information, displayName: Resource.getResourceTextSyncMode("Navigation.Icon.Info",""), enabled: true, existent: true, visible: true , imageUrl: NavigatonIcons.Information });
      StateWildBook.transitions.push(t);
     
    }
    return StateWildBook.transitions;
  }
}
